<template>
	<div class="d-flex justify-content-between align-items-center">
		<a :href="'/appointments/'+appointment.id">
			{{ appointmentLabel }}
			<i v-if="isCore || isShort" 
				aria-hidden="true"
				:class="['bi bi-circle-fill', isCore ? 'text-visit-core' : 'text-visit-short']"
				></i>
		</a>
	    <div v-if="appointment.appointment_status.name == 'Scheduled'" class="dropdown">
	        <button class="btn btn-link text-secondary" type="button" :id="'appointmentMenuButton'+appointment.id" data-bs-toggle="dropdown" aria-expanded="false">
	            <icon-calendar :width=16 :height=16 />
	        </button>
	        <ul class="dropdown-menu dropdown-menu-end" :aria-labelledby="'appointmentMenuButton'+appointment.id">
	            <li><a class="dropdown-item" :href="'/appointments/'+appointment.id+'/edit'">Edit</a></li>
	        </ul>
	    </div>
	    <div v-else class="px-3 py-1">
	    	<component :is="statusIcon"></component>
	    </div>
	</div>
</template>

<script>
import IconCalendar from '../shared/IconCalendar.vue'
import IconCheck from '../shared/IconCheck.vue'
import IconX from '../shared/IconX.vue'

export default {
	name:"AppointmentListItem",
	components: {
		IconCalendar,
		IconCheck,
		IconX
	},
	props: {
		appointment: Object
	},
	data() {
		return {
			//
		}
	},
	computed: {
		appointmentLabel() {
			let appointment_name = this.appointment.task ? this.appointment.task.task_type_status.task_type.name : this.appointment.appointment_type.name
			return this.appointment.start_date+' at '+this.appointment.start_time+' - '+appointment_name
		},
		statusIcon() {
			return this.appointment.appointment_status.name == 'Attended' ? 'icon-check' : 'icon-x'
		},
		isCore() {
			return this.appointment?.appointment_type.slug == 'core-visit';
		},
		isShort() {
			return this.appointment?.appointment_type.slug == 'short-visit';
		}
	}

}
</script>